import { valueToBigNumber } from '@aave/protocol-js';
import React from 'react';
import { useIntl } from 'react-intl';
import Preloader from '../../../../components/basic/Preloader';
import ScreenWrapper from '../../../../components/wrappers/ScreenWrapper';
import { useStaticPoolDataContext } from '../../../../libs/pool-data-provider';
import { useWalletBalanceProviderContext } from '../../../../libs/wallet-balance-provider/WalletBalanceProvider';
import FaucetAssetTable from '../../components/FaucetAssetTable';
import { FaucetTableItem } from '../../components/FaucetAssetTable/types';
import messages from './messages';

export default function FaucetMain() {
  const intl = useIntl();
  const { userId, rawReserves, networkConfig } = useStaticPoolDataContext();

  const { walletData } = useWalletBalanceProviderContext();
  if (!walletData) {
    return <Preloader />;
  }

  const listData = rawReserves
    .filter(
      (reserve) =>
        reserve.symbol.toUpperCase() !== networkConfig.baseAsset &&
        !reserve.isFrozen &&
        reserve.isActive
    )
    .map<FaucetTableItem>((reserve) => {
      const walletBalance =
        walletData[reserve.underlyingAsset] === '0'
          ? valueToBigNumber('0')
          : valueToBigNumber(walletData[reserve.underlyingAsset] || '0').dividedBy(
              valueToBigNumber('10').pow(reserve.decimals)
            );
      return {
        ...reserve,
        walletBalance,
      };
    });

  return (
    <ScreenWrapper
      pageTitle={intl.formatMessage(messages.pageTitle)}
      isTitleOnDesktop={true}
      withMobileGrayBg={true}
    >
      <FaucetAssetTable listData={listData} userId={userId} />
    </ScreenWrapper>
  );
}
